import { type ReactNode } from "react";
import { cx } from "shared/utils/classnames";
import { useInboxEmbed } from "../context/useInboxEmbed";

export const RoutingFieldsRow = ({
  from,
  to
}: {
  from: ReactNode;
  to: ReactNode;
}) => {
  const isCompact = Boolean(useInboxEmbed()?.compact);
  const groupClass = cx(
    "flex min-w-0 items-center gap-2 text-sm",
    isCompact ? "flex-1" : "shrink"
  );
  const fieldClass = cx("min-w-0", isCompact ? "flex-1" : "shrink");

  return (
    <div className="flex min-w-0 flex-row flex-nowrap items-center gap-4">
      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          From:
        </span>
        <div className={fieldClass}>{from}</div>
      </div>

      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          To:
        </span>
        <div className={fieldClass}>{to}</div>
      </div>
    </div>
  );
};
